const notesOverview = (function () {
  // DOM
  let overviewTable;
  // Values & Data
  let billersData;
  let consumerDropdownData;
  let serviceBillingCodes;
  let needDropdownData;
  let serviceDropdownData;
  let locationDropdownData;
  let contactDropdownData;
  let caseLoadRestriction;
  let groups;
  let tableConsumers;
  //PERMISSIONS
  let viewEntered;
  let caseloadOnly;
  // table load vals
  let isSSANote;
  // id array
  let noteIds = [];
  let overLapIds = [];
  let reviewAttachmentList;
  let attachcount;

  // UTIL
  //---------------------------------------------
  function getServiceDateDefaultValues(startOrEnd) {
    var dateOffset = 24 * 60 * 60 * 1000 * parseInt($.session.defaultCaseNoteReviewDays);
    var todaysDate = new Date();
    var daysBackDate = new Date();
    var newDate;
    daysBackDate.setTime(daysBackDate.getTime() - dateOffset);
    if (startOrEnd === 'start') {
      newDate =
        daysBackDate.getFullYear() +
        '-' +
        ('0' + (daysBackDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + daysBackDate.getDate()).slice(-2);
    } else {
      newDate =
        todaysDate.getFullYear() +
        '-' +
        ('0' + (todaysDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + todaysDate.getDate()).slice(-2);
    }

    return newDate;
  }
  function buildMutationObserver() {
    var observNode = document.getElementById('actioncenter');
    var config = { attributes: true };
    var callback = function (mutationList, observer) {
      for (let mutation of mutationList) {
        if (mutation.type === 'attributes') {
          if (
            mutation.target.dataset.activeSection === 'caseNotes-new' ||
            mutation.target.dataset.activeSection === 'caseNotes-review'
          ) {
            observer.disconnect();
          } else if (mutation.attributeName === 'data-active-section') {
            observer.disconnect();
            miniRosterBtn = document.querySelector('.consumerListBtn');
            if (miniRosterBtn) miniRosterBtn.classList.remove('disabled');
          }
          //*FILTER: Reset filter values when leaving casenotes
          // if (mutation.target.dataset.activeModule !== 'casenotes') {
          //   resetFilterValues();
          // }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(observNode, config);
  }
  function disableMiniRosterBtn() {
    var btn = document.querySelector('.consumerListBtn');
    if (btn) btn.classList.add('disabled');
  }
  function groupDropdownDataFromGetCNPopulateFilterDropdowns(rawData = []) {
    serviceBillingCodes = [{ value: '%', text: 'All' }];
    needDropdownData = [{ value: '%', text: 'All' }];
    serviceDropdownData = [{ value: '%', text: 'All' }];
    locationDropdownData = [{ value: '%', text: 'All' }];
    contactDropdownData = [{ value: '%', text: 'All' }];

    rawData.sort((a, b) => a.caption.localeCompare(b.caption, undefined, { sensitivity: 'base' }));

    rawData.forEach(d => {
      const dropdownOption = { text: d.caption, value: d.note_code };

      if (d.dropdown === 'ServiceCode') serviceBillingCodes.push(dropdownOption);
      if (d.dropdown === 'Need') needDropdownData.push(dropdownOption);
      if (d.dropdown === 'Service') serviceDropdownData.push(dropdownOption);
      if (d.dropdown === 'Contact') contactDropdownData.push(dropdownOption);
      if (d.dropdown === 'Location') locationDropdownData.push(dropdownOption);
    });
  }

  // Attachments
  //---------------------------------------------
  function attachmentPopup() {
    const popup = POPUP.build({
      header: 'Attachments',
      id: 'cnAttachmentPopup',
    });

    addAttachmentBtn = button.build({
      text: 'Add Attachment',
      style: 'secondary',
      type: 'text',
      icon: 'add',
      // callback: addNewAttachment
    });
    addAttachmentBtn.type = 'button';
    removeAttachmentBtn = button.build({
      style: 'secondary',
      type: 'text',
      icon: 'delete',
    });
    removeAttachmentBtn.type = 'button';
    // addRemoveAttachmentEventListener(removeAttachmentBtn);
    const saveBtn = button.build({
      id: 'attachmentSave',
      text: 'Done',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        // saveAction();
        POPUP.hide(popup);
      },
    });
    // const cancelBtn = button.build({
    //   id: "attachmentCancel",
    //   text: "cancel",
    //   style: "secondary",
    //   type: "outlined",
    //   callback: () => {
    //     POPUP.hide(popup);
    //   }
    // });

    reviewAttachmentList = document.createElement('div');
    reviewAttachmentList.classList.add('reviewAttachmentList');
    newAttachmentList = document.createElement('div');
    newAttachmentList.classList.add('newAttachmentList');
    const newAttachmentsHeader = document.createElement('h5');
    newAttachmentsHeader.innerText = 'Attachments to be added:';
    // if (isBatched === '' || isBatched === null) {
    //     newAttachmentList.appendChild(newAttachmentsHeader);
    // }

    attachmentInput = document.createElement('input');
    attachmentInput.type = 'file';
    attachmentInput.classList.add('input-field__input', 'attachmentInput');
    attachmentInput.onchange = event => fileValidation(event.target);

    attachmentContainer = document.createElement('div');
    attachmentContainer.classList.add('attachmentContainer');
    attachmentList = document.createElement('form');
    attachmentList.setAttribute('id', 'attachmentForm');
    // if (isBatched === '' || isBatched === null) {
    //     attachmentList.appendChild(attachmentContainer);
    //     attachmentContainer.appendChild(removeAttachmentBtn);
    //     attachmentContainer.appendChild(attachmentInput);
    // }
    // attachmentContainer.appendChild(addAttachmentBtn);

    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');

    popup.appendChild(reviewAttachmentList);
    popup.appendChild(newAttachmentList);
    popup.appendChild(attachmentList);
    // if (isBatched === '' || isBatched === null) {
    //     popup.appendChild(addAttachmentBtn);
    // }

    btnWrap.appendChild(saveBtn);
    //  btnWrap.appendChild(cancelBtn);
    popup.appendChild(btnWrap);
    POPUP.show(popup);
  }
  function populateExistingAttachments(reviewAttachments) {
    const header = document.createElement('h5');
    header.innerText = 'Select an attachment to view:';
    reviewAttachmentList.appendChild(header);

    reviewAttachments.forEach(attachment => {
      const fileContainer = document.createElement('div');
      fileContainer.classList.add('reviewAttachmentContainer');
      fileContainer.setAttribute('id', attachment.attachmentId);
      fileContainer.setAttribute('delete', false);

      const removeAttachmentBtn = button.build({
        style: 'secondary',
        type: 'text',
        icon: 'delete',
        // callback: event => addRemoveAttachmentToDeleteList(event.target.parentElement)
      });

      const file = document.createElement('p');
      file.innerText = attachment.description;
      // if (isBatched === '' || isBatched === null) {
      //     fileContainer.appendChild(removeAttachmentBtn);
      // }
      fileContainer.appendChild(file);
      file.addEventListener('click', event => {
        const attachmentId = event.target.parentElement.id;
        caseNotesAjax.viewCaseNoteAttachment(attachmentId);
      });
      reviewAttachmentList.appendChild(fileContainer);
    });
  }

  // Top Bar
  //---------------------------------------------
  function buildConsumerSearch() {
    const searchBtn = button.build({
      id: 'searchBtn',
      text: 'Search',
      icon: 'search',
      style: 'secondary',
      type: 'contained',
    });

    const searchInput = document.createElement('input');
    searchInput.setAttribute('placeholder', 'search consumers');

    const searchWrap = document.createElement('div');
    searchWrap.classList.add('consumerSearch');
    searchWrap.appendChild(searchBtn);
    searchWrap.appendChild(searchInput);

    searchBtn.addEventListener('click', event => {
      searchWrap.classList.toggle('searchOpen');
      searchInput.value = '';
      searchInput.focus();
    });
    searchInput.addEventListener('keyup', event => {
      if (event.keyCode === 13) {
        tableConsumerSearch(event.target.value);
      }
    });

    return searchWrap;
  }
  function buildTopBar() {
    const topBarWrap = document.createElement('div');

    const consumerSearch = buildConsumerSearch();

    const newNoteBtn = button.build({
      text: 'New Note',
      style: 'secondary',
      type: 'contained',
      icon: 'add',
      callback: async function () {
        //await CaseNotes.init();
        await CaseNotes.loadPage();
      },
    });

    const cnReportBtn = generateReports.createMainReportButton([
      { text: 'Detail Report', filterValues },
      { text: 'Minutes By Date', filterValues },
      { text: 'Time Analysis Report', filterValues },
      { text: 'TXX Case Notes', filterValues },
    ]);

    const cnADVReportBtn = generateReports.createMainReportButton([
      { text: 'Detailed Case Notes By Biller', filterValues },
      { text: 'Minutes By Date', filterValues },
    ]);

    const multiSelectBtns = buildMultiSelectButtons();

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('cnbtnWrap');

    if ($.session.CaseNotesUpdate) {
      buttonWrap.appendChild(newNoteBtn);
    }
    if ($.session.applicationName === 'Gatekeeper') {
      buttonWrap.appendChild(cnReportBtn);
    } else {
      buttonWrap.appendChild(cnADVReportBtn);
    }

    topBarWrap.appendChild(buttonWrap);

    if ($.session.CaseNotesReview) {
      topBarWrap.appendChild(multiSelectBtns);
    }

    topBarWrap.appendChild(consumerSearch);

    return topBarWrap;
  }

  // Filtering
  //---------------------------------------------
  $.session.caseNotesReviewFilterValues = null;
  $.session.caseNotesReviewFilterDisplayValues = null;
  $.session.caseNotesReviewAdditionalFilterValues = null;

  let filterValues = {};
  let tempFilterValues = {};
  let filterDisplayValues = {};
  let tempFilterDisplayValues = {};
  let activeAdditionalFilters = {};
  let filterObj = {};

  function initFilterValues({ consumer, consumerName, serviceDateStart } = {}) {
    if ($.session.caseNotesReviewFilterValues) {
      filterValues = { ...$.session.caseNotesReviewFilterValues };
    } else {
      filterValues = {
        attachments: '%',
        biller: $.session.PeopleId,
        billed: '%',
        billingCode: '%',
        consumer: consumer ? consumer : '%',
        contact: '%',
        confidential: '%',
        corrected: '%',
        enteredDateStart: '1900-01-01',
        enteredDateEnd: UTIL.getTodaysDate(),
        location: '%',
        need: '%',
        noteText: '%',
        overlaps: $.session.caseNotesOverlapFilter ? 'Y' : 'N',
        outcomeServiceMonitoring: '%',
        reviewStatus: '%',
        serviceDateStart: serviceDateStart ? serviceDateStart : getServiceDateDefaultValues('start'),
        serviceDateEnd: getServiceDateDefaultValues('end'),
        service: '%',
      };
    }

    if ($.session.caseNotesReviewFilterDisplayValues) {
      filterDisplayValues = { ...$.session.caseNotesReviewFilterDisplayValues };
    } else {
      filterDisplayValues = {
        attachments: '',
        biller: '',
        billed: '',
        billingCode: '',
        consumer: consumerName ? consumerName : '',
        corrected: '',
        contact: '',
        confidential: '',
        createdDates: `Created Dates: ${dates.formateToStandard(
          filterValues.enteredDateStart,
        )} - ${dates.formateToStandard(filterValues.enteredDateEnd)}`,
        location: '',
        need: '',
        noteText: '',
        overlaps: `Overlaps: ${$.session.caseNotesOverlapFilter ? 'Yes' : 'No'}`,
        outcomeServiceMonitoring: '',
        reviewStatus: '',
        serviceDates: `Service Dates: ${dates.formateToStandard(
          filterValues.serviceDateStart,
        )} - ${dates.formateToStandard(filterValues.serviceDateEnd)}`,
        service: '',
      };
    }

    if ($.session.caseNotesReviewAdditionalFilterValues) {
      activeAdditionalFilters = { ...$.session.caseNotesReviewAdditionalFilterValues };
    } else {
      activeAdditionalFilters = {
        location: false,
        service: false,
        need: false,
        contact: false,
        confidential: false,
        billed: false,
        attachments: false,
        noteText: false,
      };
    }

    initFilterObj();
  }
  function initFilterObj() {
    filterObj = {
      biller: {
        button: button.build({
          text: 'Biller: ' + filterDisplayValues.biller,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'biller' }],
        }),
        input: dropdown.build({
          dropdownId: 'billerDropdown',
          label: 'Biller',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.biller = targetOpt.value;
            tempFilterDisplayValues.biller = `Biller: ${targetOpt.textContent}`;
          },
        }),
      },
      consumer: {
        button: button.build({
          text: 'Consumer: ' + filterDisplayValues.consumer,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'consumer' }],
        }),
        input: dropdown.build({
          dropdownId: 'consumerDropdown',
          label: 'Consumer',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.consumer = targetOpt.value;
            tempFilterDisplayValues.consumer = `Consumer: ${targetOpt.textContent}`;
          },
        }),
      },
      billingCode: {
        button: button.build({
          text:
            $.session.applicationName === 'Gatekeeper'
              ? 'Billing Code: '
              : `Service Code: ${filterDisplayValues.billingCode}`,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'billingCode' }],
        }),
        input: dropdown.build({
          dropdownId: 'billingCodeDropdown',
          label: $.session.applicationName === 'Gatekeeper' ? 'Billing Code' : 'Service Code',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.billingCode = targetOpt.value;
            const label = $.session.applicationName === 'Gatekeeper' ? 'Billing Code:' : 'Service Code:';
            tempFilterDisplayValues.billingCode = `${label} ${targetOpt.textContent}`;
          },
        }),
      },
      reviewStatus: {
        button: button.build({
          text: 'Review Status: ' + filterDisplayValues.reviewStatus,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'reviewStatus' }],
        }),
        input: dropdown.build({
          dropdownId: 'reviewStatusDropdown',
          label: 'Review Status',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.reviewStatus = targetOpt.value;
            tempFilterDisplayValues.reviewStatus = `Review Status: ${targetOpt.textContent}`;
          },
        }),
      },
      corrected: {
        button: button.build({
          text: 'Corrected: ' + filterDisplayValues.corrected,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'corrected' }],
        }),
        input: dropdown.build({
          dropdownId: 'correctedDropdown',
          label: 'Corrected',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.corrected = targetOpt.value;
            tempFilterDisplayValues.corrected = `Corrected: ${targetOpt.textContent}`;
          },
        }),
      },
      outcomeServiceMonitoring: {
        button: button.build({
          id: 'outcomeServiceMonitoringBtn',
          text: 'Outcome/Service Monitoring: ' + filterDisplayValues.outcomeServiceMonitoring,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'outcomeServiceMonitoring' }],
        }),
        input: dropdown.build({
          dropdownId: 'outcomeServiceMonitoringDropdown',
          label: 'Outcome/Service Monitoring',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.outcomeServiceMonitoring = targetOpt.value;
            tempFilterDisplayValues.outcomeServiceMonitoring = `Outcome/Service Monitoring: ${targetOpt.textContent}`;
          },
        }),
      },
      serviceDates: {
        button: button.build({
          id: 'serviceDatesBtn',
          text: 'Service Dates: ' + filterDisplayValues.serviceDates,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'serviceDates' }],
        }),
        input: {
          start: input.build({
            type: 'date',
            label: 'Service Date Start',
            style: 'secondary',
            value: getServiceDateDefaultValues('start'),
            callback: e => {
              tempFilterValues.serviceDateStart = e.target.value;
              const startDate = moment(tempFilterValues.serviceDateStart).format('MM/DD/YYYY');
              const endDate = moment(tempFilterValues.serviceDateEnd).format('MM/DD/YYYY');
              tempFilterDisplayValues.serviceDates = `Service Dates: ${startDate} - ${endDate}`;         
            },
          }),
          end: input.build({
            type: 'date',
            label: 'Service Date End',
            style: 'secondary',
            value: getServiceDateDefaultValues('end'),
            callback: e => {
              tempFilterValues.serviceDateEnd = e.target.value;
              const startDate = moment(tempFilterValues.serviceDateStart).format('MM/DD/YYYY');
              const endDate = moment(tempFilterValues.serviceDateEnd).format('MM/DD/YYYY');
              tempFilterDisplayValues.serviceDates = `Service Dates: ${startDate} - ${endDate}`;
            },
          }),
        },
      },
      createdDates: {
        button: button.build({
          id: 'createdDatesBtn',
          text: 'Created Dates: ' + filterDisplayValues.createdDates,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'createdDates' }],
        }),
        input: {
          start: input.build({
            type: 'date',
            label: 'Created Date Start',
            style: 'secondary',
            value: '1900-01-01',
            callback: e => {
              tempFilterValues.enteredDateStart = e.target.value;
              const startDate = moment(tempFilterValues.enteredDateStart).format('MM/DD/YYYY');
              const endDate = moment(tempFilterValues.enteredDateEnd).format('MM/DD/YYYY');
              tempFilterDisplayValues.createdDates = `Created Dates: ${startDate} - ${endDate}`;             
            },
          }),
          end: input.build({
            type: 'date',
            label: 'Created Date End',
            style: 'secondary',
            value: UTIL.getTodaysDate(),
            callback: e => {
              tempFilterValues.enteredDateEnd = e.target.value;
              const startDate = moment(tempFilterValues.enteredDateStart).format('MM/DD/YYYY');
              const endDate = moment(tempFilterValues.enteredDateEnd).format('MM/DD/YYYY');
              tempFilterDisplayValues.createdDates = `Created Dates: ${startDate} - ${endDate}`;             
            },
          }),
        },
      },
      overlaps: {
        button: button.build({
          id: 'showOverlapsBtn',
          text: 'Show Overlaps: ' + filterDisplayValues.overlaps,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'overlaps' }],
        }),
        input: input.buildCheckbox({
          text: 'Check For Overlaps',
          isChecked: $.session.caseNotesOverlapFilter ? true : false,
          callback: e => {
            tempFilterValues.overlaps = e.target.checked ? 'Y' : 'N';
            tempFilterDisplayValues.overlaps = `Overlaps: ${e.target.checked ? 'Yes' : 'No'}`;
          },
        }),
      },
      //
      location: {
        button: button.build({
          id: 'locationBtn',
          text: 'Location: ' + filterDisplayValues.location,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'location' }],
        }),
        input: dropdown.build({
          dropdownId: 'locationDropdown',
          label: 'Location',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.location = targetOpt.value;
            tempFilterDisplayValues.location = `Location: ${targetOpt.textContent}`;
          },
        }),
      },
      service: {
        button: button.build({
          id: 'serviceBtn',
          text: 'Service: ' + filterDisplayValues.service,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'service' }],
        }),
        input: dropdown.build({
          dropdownId: 'serviceDropdown',
          label: 'Service',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.service = targetOpt.value;
            tempFilterDisplayValues.service = `Service: ${targetOpt.textContent}`;
          },
        }),
      },
      need: {
        button: button.build({
          id: 'needBtn',
          text: 'Need: ' + filterDisplayValues.need,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'need' }],
        }),
        input: dropdown.build({
          dropdownId: 'needDropdown',
          label: 'Need',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.need = targetOpt.value;
            tempFilterDisplayValues.need = `Need: ${targetOpt.textContent}`;
          },
        }),
      },
      contact: {
        button: button.build({
          id: 'contactBtn',
          text: 'Contact: ' + filterDisplayValues.contact,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'contact' }],
        }),
        input: dropdown.build({
          dropdownId: 'contactDropdown',
          label: 'Contact',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.contact = targetOpt.value;
            tempFilterDisplayValues.contact = `Contact: ${targetOpt.textContent}`;
          },
        }),
      },
      confidential: {
        button: button.build({
          id: 'confidentialBtn',
          text: 'Confidential: ' + filterDisplayValues.confidential,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'confidential' }],
        }),
        input: dropdown.build({
          dropdownId: 'confidentialDropdown',
          label: 'Confidential',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.confidential = targetOpt.value;
            tempFilterDisplayValues.confidential = `Confidential: ${targetOpt.textContent}`;
          },
        }),
      },
      attachments: {
        button: button.build({
          id: 'attachmentsBtn',
          text: 'Attachments: ' + filterDisplayValues.attachments,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'attachments' }],
        }),
        input: dropdown.build({
          dropdownId: 'attachmentsDropdown',
          label: 'Attachments',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.attachments = targetOpt.value;
            tempFilterDisplayValues.attachments = `Attachments: ${targetOpt.textContent}`;
          },
        }),
      },
      billed: {
        button: button.build({
          id: 'billedBtn',
          text: 'Billed: ' + filterDisplayValues.billed,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'billed' }],
        }),
        input: dropdown.build({
          dropdownId: 'billedDropdown',
          label: 'Billed',
          style: 'secondary',
          callback: (e, targetOpt) => {
            tempFilterValues.billed = targetOpt.value;
            tempFilterDisplayValues.billed = `Billed: ${targetOpt.textContent}`;
          },
        }),
      },
      noteText: {
        button: button.build({
          id: 'noteTextBtn',
          text: 'Note Text: ' + filterDisplayValues.noteText,
          style: 'secondary',
          type: 'text',
          classNames: 'filterSelectionBtn',
          attributes: [{ key: 'data-filterId', value: 'noteText' }],
        }),
        input: {
          dropdown: dropdown.build({
            dropdownId: 'noteTextDropdown',
            label: 'Note Text',
            style: 'secondary',
            callback: (e, targetOpt) => {
              if (targetOpt.value === '%') {
                tempFilterValues.noteText = '%';
                tempFilterDisplayValues.noteText = '';

                filterObj.noteText.input.text.style.display = 'none';
                filterObj.noteText.input.text.querySelector('input').value = '';
                return;
              }
              if (targetOpt.value === 'blank') {
                tempFilterValues.noteText = '';
                tempFilterDisplayValues.noteText = '';

                filterObj.noteText.input.text.style.display = 'none';
                filterObj.noteText.input.text.querySelector('input').value = '';
                return;
              }

              filterObj.noteText.input.text.style.display = 'flex';
            },
          }),
          text: input.build({
            label: 'Note Text',
            style: 'secondary',
            callback: e => {
              tempFilterValues.noteText = e.target.value;
              tempFilterDisplayValues.noteText = `Note Text: ${e.target.value}`;
            },
          }),
        },
      },
    };
  }
  // dropdowns
  function populateConsumersDropdown() {
    const data = consumerDropdownData.map(el => {
      return {
        text: `${el.LN}, ${el.FN}`,
        value: el.id,
      };
    });

    data.unshift({ text: 'All', value: '%' });

    dropdown.populate(filterObj.consumer.input, data, filterValues.consumer);
  }
  function populateBillersDropdown() {
    const data = billersData.map(b => {
      return {
        value: b.billerId,
        text: b.billerName,
      };
    });

    data.unshift({ value: '%', text: 'All' });

    dropdown.populate(filterObj.biller.input, data, filterValues.biller);
  }
  function populateReviewStatusDropdown() {
    const data = [
      { text: 'All', value: '%' },
      { text: 'Not Reviewed', value: 'N' },
      { text: 'Passed', value: 'P' },
      { text: 'Rejected', value: 'R' },
    ];
    dropdown.populate(filterObj.reviewStatus.input, data, filterValues.reviewStatus);
  }
  function populateNotetextDropdown() {
    const data = [
      { text: 'All', value: '%' },
      { text: 'Blank', value: 'blank' },
      { text: 'Contains', value: 'contains' },
    ];

    let defaultValue;

    if (filterValues.noteText === '%') {
      defaultValue = '%';
    } else if (filterValues.noteText === '') {
      defaultValue = 'blank';
    } else {
      defaultValue = 'contains';
    }

    dropdown.populate(filterObj.noteText.input.dropdown, data, defaultValue);
  }
  function populateBillingServiceCodeDropdown() {
    dropdown.populate(filterObj.billingCode.input, serviceBillingCodes, filterValues.billingCode);
  }
  function populateLocationDropdown() {
    dropdown.populate(filterObj.location.input, locationDropdownData, filterValues.location);
  }
  function populateServiceDropdown() {
    dropdown.populate(filterObj.service.input, serviceDropdownData, filterValues.service);
  }
  function populateNeedDropdown() {
    dropdown.populate(filterObj.need.input, needDropdownData, filterValues.need);
  }
  function populateContactDropdown() {
    dropdown.populate(filterObj.contact.input, contactDropdownData, filterValues.contact);
  }
  const sharedDropdownData = [
    { text: 'All', value: '%' },
    { text: 'Yes', value: 'Y' },
    { text: 'No', value: 'N' },
  ];
  function populateAttachmentsDropdown() {
    dropdown.populate(filterObj.attachments.input, sharedDropdownData, filterValues.attachments);
  }
  function populateBilledDropdown() {
    dropdown.populate(filterObj.billed.input, sharedDropdownData, filterValues.billed);
  }
  function populateConfidentialDropdown() {
    dropdown.populate(filterObj.confidential.input, sharedDropdownData, filterValues.confidential);
  }
  function populateCorrectedDropdown() {
    dropdown.populate(filterObj.corrected.input, sharedDropdownData, filterValues.corrected);
  }
  function populateOutcomeMonitoringDropdown() {
    dropdown.populate(
      filterObj.outcomeServiceMonitoring.input,
      sharedDropdownData,
      filterValues.outcomeServiceMonitoring,
    );
  }
  const populateDropdownFuncMap = {
    biller: populateBillersDropdown,
    consumer: populateConsumersDropdown,
    reviewStatus: populateReviewStatusDropdown,
    noteText: populateNotetextDropdown,
    attachments: populateAttachmentsDropdown,
    billed: populateBilledDropdown,
    confidential: populateConfidentialDropdown,
    corrected: populateCorrectedDropdown,
    outcomeServiceMonitoring: populateOutcomeMonitoringDropdown,
    serviceBillingCodes: populateBillingServiceCodeDropdown,
    location: populateLocationDropdown,
    service: populateServiceDropdown,
    need: populateNeedDropdown,
    contact: populateContactDropdown,
  };
  // main filter popup
  function hideShowAdditionalFilters(additionalFilterWrap) {
    Object.keys(activeAdditionalFilters).forEach(key => {
      const showInput = activeAdditionalFilters[key];

      if (showInput) {
        if (key === 'noteText') {
          additionalFilterWrap.append(filterObj[key].input.dropdown);
          additionalFilterWrap.append(filterObj[key].input.text);
          filterObj[key].input.text.style.display = 'none';
        } else {
          additionalFilterWrap.append(filterObj[key].input);
        }

        if (populateDropdownFuncMap[key]) {
          populateDropdownFuncMap[key]();
        }
      } else {
        if (key === 'noteText') {
          filterObj[key].input.dropdown.remove();
          filterObj[key].input.text.remove();
        } else {
          filterObj[key].input.remove();
        }

        filterValues[key] = '%';
      }
    });
  }
  function showAdditionalFiltersPopup(callback) {
    const tempAdditionalFilterValues = { ...activeAdditionalFilters };

    const additionalFiltersPopup = POPUP.build({
      hideX: true,
      classNames: 'additionalFiltersPopup',
    });

    const cBoxContainer = document.createElement('div');
    cBoxContainer.classList.add('cboxContainer');

    const selectAllFilter = input.buildCheckbox({
      text: 'Select All',
      attributes: [{ key: 'data-filterId', value: 'all' }],
    });
    const locationFilter = input.buildCheckbox({
      text: 'Location',
      isChecked: activeAdditionalFilters.location,
      attributes: [{ key: 'data-filterId', value: 'location' }],
    });
    const serviceFilter = input.buildCheckbox({
      text: 'Service',
      isChecked: activeAdditionalFilters.service,
      attributes: [{ key: 'data-filterId', value: 'service' }],
    });
    const needFilter = input.buildCheckbox({
      text: 'Need',
      isChecked: activeAdditionalFilters.need,
      attributes: [{ key: 'data-filterId', value: 'need' }],
    });
    const contactFilter = input.buildCheckbox({
      text: 'Contact',
      isChecked: activeAdditionalFilters.contact,
      attributes: [{ key: 'data-filterId', value: 'contact' }],
    });
    const confidentialFilter = input.buildCheckbox({
      text: 'Confidential',
      isChecked: activeAdditionalFilters.confidential,
      attributes: [{ key: 'data-filterId', value: 'confidential' }],
    });
    const billedFilter = input.buildCheckbox({
      text: 'Billed',
      isChecked: activeAdditionalFilters.billed,
      attributes: [{ key: 'data-filterId', value: 'billed' }],
    });
    const attachmentsFilter = input.buildCheckbox({
      text: 'Attachments',
      isChecked: activeAdditionalFilters.attachments,
      attributes: [{ key: 'data-filterId', value: 'attachments' }],
    });
    const noteTextFilter = input.buildCheckbox({
      text: 'Note Text',
      isChecked: activeAdditionalFilters.noteText,
      attributes: [{ key: 'data-filterId', value: 'noteText' }],
    });

    const applyBtn = button.build({
      text: 'apply',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        additionalFiltersPopup.remove();
        activeAdditionalFilters = { ...activeAdditionalFilters, ...tempAdditionalFilterValues };
        callback('apply');
      },
    });
    const cancelBtn = button.build({
      text: 'cancel',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        additionalFiltersPopup.remove();
        callback('cancel');
      },
    });

    cBoxContainer.appendChild(selectAllFilter);
    cBoxContainer.appendChild(locationFilter);
    cBoxContainer.appendChild(serviceFilter);
    cBoxContainer.appendChild(needFilter);
    cBoxContainer.appendChild(contactFilter);
    cBoxContainer.appendChild(confidentialFilter);
    cBoxContainer.appendChild(billedFilter);
    if ($.session.applicationName === 'Gatekeeper') {
      cBoxContainer.appendChild(attachmentsFilter);
    }
    cBoxContainer.appendChild(noteTextFilter);

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(applyBtn);
    buttonWrap.appendChild(cancelBtn);

    additionalFiltersPopup.appendChild(cBoxContainer);
    additionalFiltersPopup.appendChild(buttonWrap);

    cBoxContainer.addEventListener('change', e => {
      const filterId = e.target.dataset.filterid;

      if (filterId === 'all') {
        Object.keys(tempAdditionalFilterValues).forEach(key => {
          tempAdditionalFilterValues[key] = e.target.checked;
        });

        [
          selectAllFilter,
          locationFilter,
          serviceFilter,
          needFilter,
          contactFilter,
          confidentialFilter,
          billedFilter,
          attachmentsFilter,
          noteTextFilter,
        ].forEach(filter => {
          filter.querySelector('input').checked = e.target.checked;
        });

        return;
      }

      tempAdditionalFilterValues[filterId] = e.target.checked;
    });

    POPUP.show(additionalFiltersPopup);
  }
  function showFilterPopup() {
    tempFilterValues = { ...filterValues };
    tempFilterDisplayValues = { ...filterDisplayValues };

    const filterPopup = POPUP.build({
      hideX: true,
      classNames: 'caseNoteReviewFilterPopup',
    });

    const showMoreFiltersBtn = button.build({
      text: 'more filter options',
      style: 'secondary',
      type: 'text',
      callback: () => {
        filterPopup.style.display = 'none';

        showAdditionalFiltersPopup(applyOrCancel => {
          filterPopup.style.display = 'block';

          if (applyOrCancel === 'cancel') {
            return;
          }

          $.session.caseNotesReviewAdditionalFilterValues = { ...activeAdditionalFilters };

          hideShowAdditionalFilters(additionalFilterWrap);
        });
      },
    });

    const additionalFilterWrap = document.createElement('div');
    hideShowAdditionalFilters(additionalFilterWrap);

    const applyBtn = button.build({
      text: 'Apply',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        POPUP.hide(filterPopup);

        if (filterValues.overlaps !== tempFilterValues.overlaps) {
          caseNotesAjax.updateOverlapFilterValue(tempFilterValues.overlaps);
          $.session.caseNotesOverlapFilter = tempFilterValues.overlaps === 'Y' ? true : false;
        }

        filterValues = { ...filterValues, ...tempFilterValues };
        filterDisplayValues = { ...filterDisplayValues, ...tempFilterDisplayValues };

        $.session.caseNotesReviewFilterValues = { ...filterValues };
        $.session.caseNotesReviewFilterDisplayValues = { ...filterDisplayValues };

        updateCurrentFilterDisplay();

        getTableData();
      },
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      callback: function () {
        POPUP.hide(filterPopup);

        //TODO: reset non dropdown filter values to their filterValues.ID
        const sdStart = filterObj.serviceDates.input.start.querySelector('input');
        const sdEnd = filterObj.serviceDates.input.end.querySelector('input');
        const cdStart = filterObj.createdDates.input.start.querySelector('input');
        const cdEnd = filterObj.createdDates.input.end.querySelector('input');
        const overlap = filterObj.overlaps.input.querySelector('input');
        sdStart.value = filterValues.serviceDateStart;
        sdEnd.value = filterValues.serviceDateEnd;
        cdStart.value = filterValues.enteredDateStart;
        cdEnd.value = filterValues.enteredDateEnd;
        overlap.checked = filterValues.overlaps === 'Y' ? true : false;
      },
    });

    filterPopup.appendChild(filterObj.overlaps.input);
    filterPopup.appendChild(filterObj.biller.input);
    filterPopup.appendChild(filterObj.consumer.input);
    filterPopup.appendChild(filterObj.billingCode.input);
    filterPopup.appendChild(filterObj.reviewStatus.input);

    if ($.session.applicationName === 'Gatekeeper') {
      filterPopup.appendChild(filterObj.corrected.input);
      filterPopup.appendChild(filterObj.outcomeServiceMonitoring.input);
    }

    const serviceDateWrap = document.createElement('div');
    serviceDateWrap.classList.add('btnWrap');
    serviceDateWrap.appendChild(filterObj.serviceDates.input.start);
    serviceDateWrap.appendChild(filterObj.serviceDates.input.end);
    filterPopup.appendChild(serviceDateWrap);

    const createDateWrap = document.createElement('div');
    createDateWrap.classList.add('btnWrap');
    createDateWrap.appendChild(filterObj.createdDates.input.start);
    createDateWrap.appendChild(filterObj.createdDates.input.end);
    filterPopup.appendChild(createDateWrap);

    filterPopup.appendChild(additionalFilterWrap);
    filterPopup.appendChild(showMoreFiltersBtn);

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(applyBtn);
    buttonWrap.appendChild(cancelBtn);
    filterPopup.appendChild(buttonWrap);

    populateBillersDropdown();
    populateConsumersDropdown();
    populateBillingServiceCodeDropdown();
    populateReviewStatusDropdown();

    if ($.session.applicationName === 'Gatekeeper') {
      populateOutcomeMonitoringDropdown();
      populateCorrectedDropdown();
    }

    POPUP.show(filterPopup);
  }
  // current filter display
  function showMiniFilterPopup(filterId) {
    tempFilterValues = { ...filterValues };
    tempFilterDisplayValues = { ...filterDisplayValues };

    const miniFilterPopup = POPUP.build({
      classNames: 'caseNoteReviewFilterPopup',
    });

    if (filterId === 'serviceDates') {
      miniFilterPopup.appendChild(filterObj.serviceDates.input.start);
      miniFilterPopup.appendChild(filterObj.serviceDates.input.end);
    } else if (filterId === 'createdDates') {
      miniFilterPopup.appendChild(filterObj.createdDates.input.start);
      miniFilterPopup.appendChild(filterObj.createdDates.input.end);
    } else if (filterId === 'noteText') {
      miniFilterPopup.appendChild(filterObj.noteText.input.dropdown);
      miniFilterPopup.appendChild(filterObj.noteText.input.text);
    } else {
      miniFilterPopup.appendChild(filterObj[filterId].input);
    }

    if (populateDropdownFuncMap[filterId]) {
      populateDropdownFuncMap[filterId]();
    }

    const applyBtn = button.build({
      text: 'Apply',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        POPUP.hide(miniFilterPopup);

        if (filterId === 'overlaps' && filterValues.overlaps !== tempFilterValues.overlaps) {
          caseNotesAjax.updateOverlapFilterValue(tempFilterValues.overlaps);
          $.session.caseNotesOverlapFilter = tempFilterValues.overlaps === 'Y' ? true : false;
        }

        filterValues = { ...filterValues, ...tempFilterValues };
        filterDisplayValues = { ...filterDisplayValues, ...tempFilterDisplayValues };

        $.session.caseNotesReviewFilterValues = { ...filterValues };
        $.session.caseNotesReviewFilterDisplayValues = { ...filterDisplayValues };

        updateCurrentFilterDisplay();

        getTableData();
      },
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      callback: function () {
        POPUP.hide(miniFilterPopup);

        //TODO: reset non dropdown filter values to their filterValues.ID
        const sdStart = filterObj.serviceDates.input.start.querySelector('input');
        const sdEnd = filterObj.serviceDates.input.end.querySelector('input');
        const cdStart = filterObj.createdDates.input.start.querySelector('input');
        const cdEnd = filterObj.createdDates.input.end.querySelector('input');
        const overlap = filterObj.overlaps.input.querySelector('input');
        sdStart.value = filterValues.serviceDateStart;
        sdEnd.value = filterValues.serviceDateEnd;
        cdStart.value = filterValues.enteredDateStart;
        cdEnd.value = filterValues.enteredDateEnd;
        overlap.checked = filterValues.overlaps === 'Y' ? true : false;
      },
    });

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(applyBtn);
    buttonWrap.appendChild(cancelBtn);
    miniFilterPopup.appendChild(buttonWrap);

    POPUP.show(miniFilterPopup);
  }
  function buildFilterBtnWrap() {
    const wrap = document.createElement('div');
    wrap.classList.add('filterSelectionBtnWrap');
    return wrap;
  }
  function buildFilterCloseBtn(filterId) {
    return button.build({
      icon: 'Delete',
      style: 'secondary',
      type: 'text',
      classNames: 'filterCloseBtn',
      attributes: [{ key: 'data-filterId', value: filterId }],
    });
  }
  function updateCurrentFilterDisplay() {
    Object.entries(filterObj).forEach(([key, value]) => {
      if (key === 'overlaps') {
        filterObj.overlaps.button.textContent = filterDisplayValues.overlaps;
        return;
      }

      if (key === 'serviceDates') {
        if (!filterValues.serviceDateStart || !filterValues.serviceDateEnd) {
          value.wrap.style.display = 'none';
        } else {
          filterObj.serviceDates.button.textContent = filterDisplayValues.serviceDates;
          value.wrap.style.display = 'flex';
        }

        return;
      }

      if (key === 'createdDates') {
        if (!filterValues.serviceDateStart || !filterValues.serviceDateEnd) {
          value.wrap.style.display = 'none';
        } else {
          filterObj.createdDates.button.textContent = filterDisplayValues.createdDates;
          value.wrap.style.display = 'flex';
        }

        return;
      }

      if (key === 'noteText') {
        if (filterValues.noteText === '%' || filterValues.noteText === '') {
          value.wrap.style.display = 'none';
        } else {
          filterObj.noteText.button.textContent = filterDisplayValues.noteText;
          value.wrap.style.display = 'flex';
        }
      }

      if (filterValues[key] === '%') {
        value.wrap.style.display = 'none';
      } else {
        filterObj[key].button.textContent = filterDisplayValues[key];
        value.wrap.style.display = 'flex';
      }
    });
  }
  function buildCurrentFilterDisplay() {
    const currentFilterDisplay = document.createElement('div');
    currentFilterDisplay.classList.add('filteredByData');
    currentFilterDisplay.id = 'notesFilterDiv';

    const filterButtonWrap = document.createElement('div');
    filterButtonWrap.classList.add('filterBtnWrap');
    currentFilterDisplay.append(filterButtonWrap);

    const filterBtn = button.build({
      text: 'Filter',
      icon: 'filter',
      style: 'secondary',
      classNames: 'filterBtnNew',
    });
    filterButtonWrap.append(filterBtn);

    Object.entries(filterObj).forEach(([key, value]) => {
      const wrap = buildFilterBtnWrap();
      const closeBtn = buildFilterCloseBtn(key);
      wrap.append(value.button);

      if (key !== 'serviceDates' && key !== 'createdDates' && key !== 'overlaps') {
        wrap.append(closeBtn);
      }

      filterButtonWrap.append(wrap);

      filterObj[key].wrap = wrap;
    });

    currentFilterDisplay.addEventListener('click', e => {
      if (e.target.classList.contains('filterBtnNew')) {
        showFilterPopup();
        return;
      }

      const filterId = e.target.dataset.filterid;

      if (e.target.classList.contains('filterCloseBtn')) {
        filterValues[filterId] = '%';
        filterObj[filterId].wrap.style.display = 'none';

        if (activeAdditionalFilters[filterId]) {
          activeAdditionalFilters[filterId] = false;
        }

        getTableData();
        return;
      }

      if (e.target.classList.contains('filterSelectionBtn')) {
        showMiniFilterPopup(filterId);
        return;
      }
    });

    return currentFilterDisplay;
  }

  // Edit Note Popup
  //---------------------------------------------
  let caseNoteModule;
  let caseNoteEditPopup;
  let editingNote = false;
  function isEditing() {
    return editingNote;
  }
  async function showEditNotePopup(noteID) {
    editingNote = true;

    caseNoteEditPopup = POPUP.build({
      classNames: 'caseNoteEditPopup',
      hideX: true,
    });

    caseNoteEditPopup.appendChild(caseNoteModule);

    POPUP.show(caseNoteEditPopup);

    await CaseNotes.populateForm(noteID, groups);

    CaseNotes.setFormCancelCallback(updateData => {
      editingNote = false;
      POPUP.hide(caseNoteEditPopup);
      if (updateData) {
        getTableData();
      }
    });
    CaseNotes.setFormDeleteCallback(() => {
      editingNote = false;
      POPUP.hide(caseNoteEditPopup);
      getTableData();
    });
    CaseNotes.setFormSaveCallback(() => {
      editingNote = false;
      POPUP.hide(caseNoteEditPopup);
      getTableData();
    });
  }

  // Table
  //---------------------------------------------
  // multiselect
  let enableMultiEdit = false;
  let enableSelectAll = false;
  let selectedRows = [];
  let rejectionReasons = [];
  //
  function resetMultiSelect() {
    overviewTable.classList.remove('multiSelectEnabled');
    mulitSelectBtn.classList.remove('enabled');
    mulitSelectBtn.classList.remove('disabled');
    selectAllBtn.classList.remove('enabled');
    enableMultiEdit = false;
    enableSelectAll = false;

    selectedRows = [];

    const highlightedRows = [].slice.call(document.querySelectorAll('.table__row.selected'));
    highlightedRows.forEach(row => row.classList.remove('selected'));
  }
  function showSuccessFailPopup(success) {
    if (success) {
      successfulSave.show('SAVED');
      setTimeout(function () {
        successfulSave.hide();
      }, 1000);
    } else {
      failSave.show('ERROR SAVING');
      setTimeout(function () {
        failSave.hide();
      }, 1000);
    }
  }
  function showLoadingPopup(action) {
    const popup = POPUP.build({
      classNames: 'loadingPop',
      hideX: true,
    });

    const spinner = PROGRESS.SPINNER.get(`${action} note(s).`);
    popup.appendChild(spinner);

    POPUP.show(popup);

    return popup;
  }
  function buildRejectionReasonDropdown() {
    const rejectDropdown = dropdown.build({
      dropdownId: 'rejectReasonDropdown',
      label: 'Rejection Reason',
      style: 'secondary',
    });

    const dropdownData = rejectionReasons.map(reason => {
      return {
        value: reason.rejectionCode,
        text: `${reason.rejectionCode} - ${reason.rejectionCaption}`,
      };
    });

    dropdownData.unshift({
      value: '',
      text: '',
    });

    dropdown.populate(rejectDropdown, dropdownData, '');

    return rejectDropdown;
  }
  function showRejectionReasonPopup(callback) {
    let rejectReason;

    const popup = POPUP.build({
      classNames: 'rejectionReasonPopup',
    });

    const rejectReasonDropdown = buildRejectionReasonDropdown();
    rejectReasonDropdown.addEventListener('change', e => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      rejectReason = selectedOption.value;

      if (rejectReason !== '') {
        rejectReasonDropdown.classList.remove('error');
        applyBtn.classList.remove('disabled');
      }
    });

    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');

    const applyBtn = button.build({
      text: 'Apply',
      type: 'contained',
      style: 'secondary',
      callback: function () {
        POPUP.hide(popup);
        callback(rejectReason);
      },
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      type: 'outlined',
      style: 'secondary',
      callback: function () {
        POPUP.hide(popup);
        resetMultiSelect();
      },
    });

    rejectReasonDropdown.classList.add('error');
    applyBtn.classList.add('disabled');

    btnWrap.appendChild(applyBtn);
    btnWrap.appendChild(cancelBtn);
    popup.appendChild(rejectReasonDropdown);
    popup.appendChild(btnWrap);

    POPUP.show(popup);
  }
  function showConfimPassRejectPopup(messageText, callback) {
    const popup = POPUP.build({
      classNames: 'confimPassRejectPopup',
    });

    const message = document.createElement('p');
    message.innerHTML = messageText;

    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');

    const yesBtn = button.build({
      text: 'Yes',
      type: 'contained',
      style: 'secondary',
      callback: function () {
        POPUP.hide(popup);
        callback();
      },
    });
    const noBtn = button.build({
      text: 'No',
      type: 'contained',
      style: 'secondary',
      callback: function () {
        POPUP.hide(popup);
        resetMultiSelect();
      },
    });

    btnWrap.appendChild(yesBtn);
    btnWrap.appendChild(noBtn);
    popup.appendChild(message);
    popup.appendChild(btnWrap);

    POPUP.show(popup);
  }
  function handleActionNavEvent(target) {
    var targetAction = target.dataset.actionNav;

    if (!selectedRows || selectedRows.length === 0) {
      enableMultiEdit = false;
      mulitSelectBtn.classList.remove('enabled');
      ACTION_NAV.hide();
      return;
    }

    let success;

    if (targetAction === 'pass') {
      const passMessage = 'Are you sure you want to set the selected case notes as passed?';
      showConfimPassRejectPopup(passMessage, async () => {
        const loadingPopup = showLoadingPopup('Passing');

        success = await caseNotesAjax.passRejectCaseNotes({
          userId: $.session.UserId,
          reviewResult: 'P',
          noteIds: selectedRows,
          rejectReason: '',
        });

        POPUP.hide(loadingPopup);
        showSuccessFailPopup(success);
        resetMultiSelect();
        getTableData();
      });

      ACTION_NAV.hide();

      return;
    }

    if (targetAction === 'reject') {
      const rejectMessage = 'Are you sure you want to reject all of the selected case notes?';
      showConfimPassRejectPopup(rejectMessage, async () => {
        if ($.session.applicationName === 'Gatekeeper') {
          showRejectionReasonPopup(async rejectReason => {
            const loadingPopup = showLoadingPopup('Rejecting');
            success = await caseNotesAjax.passRejectCaseNotes({
              userId: $.session.UserId,
              reviewResult: 'R',
              noteIds: selectedRows,
              rejectReason: rejectReason,
            });

            POPUP.hide(loadingPopup);
            showSuccessFailPopup(success);
            resetMultiSelect();
            getTableData();
          });
        } else {
          const loadingPopup = showLoadingPopup('Rejecting');
          success = await caseNotesAjax.passRejectCaseNotes({
            userId: $.session.UserId,
            reviewResult: 'R',
            noteIds: selectedRows,
            rejectReason: '',
          });

          POPUP.hide(loadingPopup);
          showSuccessFailPopup(success);
          resetMultiSelect();
          getTableData();
        }
      });

      ACTION_NAV.hide();

      return;
    }
  }
  function setupActionNav() {
    var passBtn = button.build({
      text: 'Pass',
      style: 'secondary',
      type: 'contained',
      attributes: [{ key: 'data-action-nav', value: 'pass' }],
    });
    var rejectBtn = button.build({
      text: 'Reject',
      style: 'secondary',
      type: 'outlined',
      attributes: [{ key: 'data-action-nav', value: 'reject' }],
    });

    ACTION_NAV.populate([passBtn, rejectBtn]);
    ACTION_NAV.hide();
  }
  function enableMultiEditRows() {
    enableMultiEdit = !enableMultiEdit;

    mulitSelectBtn.classList.toggle('enabled');
    overviewTable.classList.toggle('multiSelectEnabled');

    if (!enableMultiEdit) {
      ACTION_NAV.hide();
    }

    selectedRows = [];
    var highlightedRows = [].slice.call(document.querySelectorAll('.table__row.selected'));
    highlightedRows.forEach(row => row.classList.remove('selected'));
  }
  function enableSelectAllRows() {
    enableSelectAll = !enableSelectAll;

    selectAllBtn.classList.toggle('enabled');

    if (enableSelectAll) {
      enableMultiEdit = true;
      mulitSelectBtn.classList.add('disabled');
      mulitSelectBtn.classList.remove('enabled');
      overviewTable.classList.add('multiSelectEnabled');
      selectAllBtn.querySelector('span').textContent = 'Select None';

      selectedRows = [];

      var rows = [].slice.call(document.querySelectorAll('.table__body .table__row'));
      rows.forEach(r => {
        if (r.dataset.selectable === 'true') {
          r.classList.add('selected');
          selectedRows.push(r.id);
        }
      });

      if (selectedRows.length > 0) {
        ACTION_NAV.show();
      }
    } else {
      ACTION_NAV.hide();
      enableMultiEdit = false;
      mulitSelectBtn.classList.remove('disabled');
      overviewTable.classList.remove('multiSelectEnabled');
      selectAllBtn.querySelector('span').textContent = 'Select All';

      selectedRows = [];

      var highlightedRows = [].slice.call(document.querySelectorAll('.table__row.selected'));
      highlightedRows.forEach(row => row.classList.remove('selected'));
    }
  }
  function buildMultiSelectButtons() {
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('actionButtonWrap');

    mulitSelectBtn = button.build({
      text: 'Multi Select',
      icon: 'multiSelect',
      style: 'secondary',
      type: 'contained',
      classNames: 'multiSelectBtn',
      callback: enableMultiEditRows,
    });
    selectAllBtn = button.build({
      text: 'Select All',
      icon: 'multiSelect',
      style: 'secondary',
      type: 'contained',
      classNames: 'selectAllBtn',
      callback: enableSelectAllRows,
    });

    btnWrap.appendChild(mulitSelectBtn);
    btnWrap.appendChild(selectAllBtn);

    return btnWrap;
  }
  function isRowSelectable(reviewRequired, reviewResult, caseManagerId, corrected) {
    //? user clicks on a white row
    //? WHERE case_notes.review_required = 'Y' AND ((case_notes.review_results = 'N')
    //? OR (case_notes.review_results = 'R' AND case_notes.corrected = 'Y')) AND the people.id in Gatekeeper (persons.person_id in Advisor) of the logged in user
    //? DOES NOT EQUAL case_notes.case_manager_id on the record in the grid on this page, select it by changing the row color from white to green;
    if ($.session.PeopleId !== caseManagerId) {
      if ($.session.applicationName === 'Gatekeeper') {
        if ((reviewRequired === 'Y' && reviewResult === 'N') || (reviewResult === 'R' && corrected === 'Y')) {
          return 'true'; // can select row GK
        }
      } else {
        if (reviewRequired === 'Y' && reviewResult === 'N') {
          return 'true'; // can select row ADV
        }
      }
    }

    return 'false'; // can NOT selct row
  }
  //
  function handleTableEvents(event) {
    const isRow = event.target.classList.contains('table__row');
    if (!isRow) {
      return;
    }

    // show row details and/or go to note review
    const caseNoteId = event.target.id;
    const isSSANote = event.target.dataset.isssanote;
    const isSelected = event.target.classList.contains('selected');

    if (enableMultiEdit) {
      if (isSelected) {
        event.target.classList.remove('selected');
        selectedRows = selectedRows.filter(sr => sr !== caseNoteId);

        if (enableSelectAll) {
          enableSelectAll = false;
          mulitSelectBtn.classList.remove('disabled');
          mulitSelectBtn.classList.add('enabled');
          selectAllBtn.classList.remove('enabled');
        }
      } else {
        event.target.classList.add('selected');
        selectedRows.push(caseNoteId);
      }

      if (selectedRows.length === 0) {
        ACTION_NAV.hide();
      } else {
        ACTION_NAV.show();
      }

      return;
    }

    if ($.session.CaseNotesSSANotes && isSSANote === 'Y') {
      caseNotesAjax.getCaseNoteEdit(caseNoteId, function (results) {
        _DOM.ACTIONCENTER.removeAttribute('data-UI');
        setActiveModuleAttribute('casenotes');
        setActiveModuleSectionAttribute('caseNotesSSA');
        noteSSA.init('review', results, groups);
      });
    } else {
      showEditNotePopup(event.target.id);
    }
  }
  function tableConsumerSearch(searchValue) {
    searchValue = searchValue.toLowerCase();
    // gather all names shown
    //reset the array containing list of consumers that are being displayed
    displayedConsumers = [searchValue];
    tableConsumers.forEach(consumer => {
      var firstName = consumer.FirstName.toLowerCase();
      var lastName = consumer.LastName.toLowerCase();
      var fullName = `${lastName}, ${firstName}`;
      var fullNameReversed = `${lastName}, ${firstName}`;
      var matchesName = fullName.indexOf(searchValue);
      var matchesNameReverse = fullNameReversed.indexOf(searchValue);
      var caseNote = document.getElementById(consumer.id);

      if (matchesName !== -1 || matchesNameReverse !== -1) {
        caseNote.classList.remove('hidden');
        displayedConsumers.push(consumer.id);
      } else {
        caseNote.classList.add('hidden');
        var index = displayedConsumers.indexOf(consumer.id);
        if (index > -1) displayedConsumers.splice(index, 1);
      }
    });
  }
  function permissions_Table(tableData) {
    var newTable = [];
    //VIEW ENTERED - can only view case notes you have entered. Can't see any other notes.
    //CASELOAD ONLY - Can only view consumers that are on your caseload (or any note that you entered. If you were the one to enter a note, this trumps any permission)
    if (viewEntered && caseloadOnly) {
      for (let tDi = 0; tDi < tableData.length; tDi++) {
        for (let cIdx = 0; cIdx < caseLoadRestriction.length; cIdx++) {
          if (
            caseLoadRestriction[cIdx].id.toUpperCase() === tableData[tDi].consumerid.split('.')[0].toUpperCase() ||
            tableData[tDi].enteredby.toUpperCase() === $.session.UserId.toUpperCase()
          ) {
            newTable.push(tableData[tDi]);
            break;
          }
        }
      }
      return newTable;
    } else if (viewEntered) {
      for (let tDi = 0; tDi < tableData.length; tDi++) {
        if (tableData[tDi].enteredby.toUpperCase() === $.session.UserId.toUpperCase()) {
          newTable.push(tableData[tDi]);
        }
      }
      return newTable;
    } else if (caseloadOnly) {
      for (let tDi = 0; tDi < tableData.length; tDi++) {
        for (let cIdx = 0; cIdx < caseLoadRestriction.length; cIdx++) {
          if (caseLoadRestriction[cIdx].id === tableData[tDi].consumerid.split('.')[0]) {
            newTable.push(tableData[tDi]);
            break;
          }
        }
      }
      return newTable;
    } else return tableData;
  }
  function getReportFilterValue() {
    filterValues = { ...filterValues, ...tempFilterValues };
    return filterValues;
  }
  function getTableData() {
    const { biller, ...retriveData } = { ...filterValues };
    retriveData.serviceDateStart = dates.formateToISO(retriveData.serviceDateStart);
    retriveData.serviceDateEnd = dates.formateToISO(retriveData.serviceDateEnd);
    retriveData.enteredDateStart = dates.formateToISO(retriveData.enteredDateStart);
    retriveData.enteredDateEnd = dates.formateToISO(retriveData.enteredDateEnd);
    retriveData.caseloadOnly = caseloadOnly;
    retriveData.viewEntered = viewEntered;
    retriveData.userId = $.session.UserId;
    retriveData.billerId = biller;

    caseNotesAjax.getFilteredCaseNotesList(retriveData, filteredData => {
      if (filteredData.length !== 0) {
        overLapIds = filteredData[0].overlaps;
      }

      populateTable(filteredData);

      groups = {};
      tableConsumers = [];

      filteredData.forEach(fd => {
        if (fd.numberInGroup !== '1') {
          const groupNoteId = fd.groupnoteid.split('.')[0];
          const consumerId = fd.consumerid.split('.')[0];
          const name = `${fd.lastname}, ${fd.firstname}`;

          if (!groups[groupNoteId]) {
            groups[groupNoteId] = { [consumerId]: name };
          }

          groups[groupNoteId][consumerId] = name;
        }
      });

      filteredData.forEach(fd => {
        var cnId = fd.casenoteid.split('.')[0];
        var firstName = fd.firstname;
        var lastName = fd.lastname;
        var obj = { id: cnId, FirstName: firstName, LastName: lastName };
        tableConsumers.push(obj);
      });
    });
  }
  function populateTable(tableData) {
    tableData = permissions_Table(tableData);

    const groupCounts = {};

    tableData.forEach(td => {
      let groupId;

      if (td.groupnoteid === null) {
        groupId = '';
      } else {
        groupId = td.groupnoteid.split('.')[0];
      }

      if (!groupCounts[groupId]) {
        groupCounts[groupId] = 0;
      }

      groupCounts[groupId]++;
    });

    const data = tableData.map(td => {
      const consumerId = td.consumerid.split('.')[0];
      const caseNoteId = td.casenoteid.split('.')[0];
      const casemanagerid = td.casemanagerid.split('.')[0];
      const originalupdateTrim = td.originalupdate.split('T')[0];
      const originalUpdate = UTIL.formatDateFromIso(originalupdateTrim);
      const servicedate = UTIL.formatDateFromIso(td.servicedate.split('T')[0]);
      const starttime = UTIL.convertFromMilitary(td.starttime);
      const endtime = UTIL.convertFromMilitary(td.endtime);
      const name = `${td.lastname}, ${td.firstname}`;
      const lastUpdateBy = td.lastupdatedby;
      const groupCount = td.numberInGroup;
      const reviewRequired = td.review_required;
      const reviewResult = td.review_result;
      const corrected = td.corrected;
      const isSelectable = isRowSelectable(reviewRequired, reviewResult, casemanagerid, corrected);

      let reviewResultString = '';
      if (reviewRequired === 'Y') {
        reviewResultString = reviewResult === 'N' ? 'Not Reviewed' : reviewResult === 'P' ? 'Passed' : 'Rejected';
      }

      let hasOverlap = false;
      if (overLapIds !== null) {
        if (overLapIds.includes(caseNoteId)) hasOverlap = true;
      }

      isSSANote = td.isSSANote;
      attachcount = td.attachcount;

      noteIds.push(caseNoteId);

      const GKendIcon =
        !attachcount || attachcount === '  ' || attachcount === '0'
          ? `<p style="display:none;">XXX</p>`
          : `${icons['attachment']}`;
      const ADVendIcon = null;

      let thisendIcon;
      if ($.session.applicationName === 'Gatekeeper') {
        thisendIcon = GKendIcon;
      } else {
        thisendIcon = ADVendIcon;
      }

      return {
        values: [servicedate, starttime, endtime, name, originalUpdate, lastUpdateBy, groupCount, reviewResultString],
        id: caseNoteId,
        overlap: hasOverlap,
        attributes: [
          { key: 'data-consumer-id', value: consumerId },
          { key: 'data-isssanote', value: isSSANote },
          { key: 'data-selectable', value: isSelectable },
        ],
        endIcon: thisendIcon,
        endIconCallback: e => {
          e.stopPropagation();
          var isParentRow = e.target.parentNode.classList.contains('table__row');
          if (!isParentRow) return;
          // show row details and/or go to note review
          var caseNoteId = e.target.parentNode.id;
          var testNoteId = 1298784;
          caseNotesAjax.getCaseNoteAttachmentsList(caseNoteId, function (results) {
            attachmentPopup();
            if (results.length !== 0) populateExistingAttachments(results);
          });
        },
        onClick: handleTableEvents,
      };
    });

    table.populate(overviewTable, data);
  }
  function buildTable() {
    let thiscolumnheadings;

    if ($.session.applicationName === 'Gatekeeper') {
      thiscolumnheadings = [
        'Service Date',
        'Start Time',
        'End Time',
        'Name',
        'Date Created',
        'User Updated',
        'Group',
        'Review Status',
        'Attach',
      ];
    } else {
      thiscolumnheadings = [
        'Service Date',
        'Start Time',
        'End Time',
        'Name',
        'Date Created',
        'User Updated',
        'Group',
        'Review Status',
      ];
    }

    const overviewTableEle = table.build({
      tableId: 'caseNotesReviewTable',
      columnHeadings: thiscolumnheadings,
      endIcon: !attachcount || attachcount === '  ' || attachcount === '0' ? false : true,
    });

    if ($.session.applicationName === 'Gatekeeper') {
      overviewTableEle.classList.add('gatekeeperCols');
    } else {
      overviewTableEle.classList.add('advisorCols');
    }

    // Set the data type for each header, for sorting purposes
    const headers = overviewTableEle.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'date'); // Service Date
    headers[1].setAttribute('data-type', 'date'); // Service Start
    headers[2].setAttribute('data-type', 'date'); // Service End
    headers[3].setAttribute('data-type', 'string'); // Name
    headers[4].setAttribute('data-type', 'date'); // Date Created
    headers[5].setAttribute('data-type', 'string'); // User Updated
    headers[6].setAttribute('data-type', 'number'); // Group
    headers[7].setAttribute('data-type', 'string'); // Review Status

    table.sortTableByHeader(overviewTableEle);

    return overviewTableEle;
  }

  // Main
  //---------------------------------------------
  async function loadPage() {
    caseNoteModule = await CaseNotes.getPage();

    spinner.remove();

    const topBar = buildTopBar();
    const filterDisplay = buildCurrentFilterDisplay();
    overviewTable = buildTable();

    DOM.ACTIONCENTER.appendChild(topBar);
    DOM.ACTIONCENTER.appendChild(filterDisplay);
    DOM.ACTIONCENTER.appendChild(overviewTable);

    updateCurrentFilterDisplay();
    getTableData();

    buildMutationObserver();
    disableMiniRosterBtn();

    document.getElementById('searchBtn').click();

    setupActionNav();
  }
  function initialData() {
    editingNote = false;

    const promArray = [];

    if (caseloadOnly) {
      const caseloadRestrictionPromise = new Promise(function (resolve, reject) {
        caseNotesAjax.getCaseLoadRestriction(res => {
          caseLoadRestriction = res;
          resolve('success');
        });
      });
      promArray.push(caseloadRestrictionPromise);
    }

    const getConsumerDropdownData = new Promise((resolve, reject) => {
      caseNotesAjax.getConsumersForCNFilter(res => {
        consumerDropdownData = res;
        resolve('success');
      });
    });
    promArray.push(getConsumerDropdownData);

    const getBillersListPromise = new Promise(function (resolve, reject) {
      caseNotesAjax.getBillersListForDropDown(res => {
        billersData = res;
        resolve('success');
      });
    });
    promArray.push(getBillersListPromise);

    Promise.all(promArray).then(async function () {
      if ($.session.applicationName === 'Gatekeeper') {
        rejectionReasons = await caseNotesAjax.getRejectionReasonDropdownData();
      }

      const dropdownsData = await caseNotesAjax.getCNPopulateFilterDropdowns(filterValues.billingCode);
      groupDropdownDataFromGetCNPopulateFilterDropdowns(dropdownsData);

      billersData.forEach(biller => {
        if (biller.billerId === filterValues.biller) {
          filterDisplayValues.biller = `Biller: ${biller.billerName}`;
        }
      });

      // pre init CaseNotes for edit popup
      await CaseNotes.init();

      loadPage();
    });
  }
  function init({ fromDashboard, filterData } = {}) {
    DOM.clearActionCenter();

    spinner = PROGRESS.SPINNER.get('Loading Case Note Review...');
    DOM.ACTIONCENTER.appendChild(spinner);

    viewEntered = $.session.CaseNotesViewEntered;
    caseloadOnly = $.session.CaseNotesCaseloadRestriction;

    setActiveModuleAttribute('casenotes2.0');
    setActiveModuleSectionAttribute('caseNotes-overview');
    _DOM.ACTIONCENTER.setAttribute('data-UI', true);

    if (!fromDashboard) {
      initFilterValues();
      initialData();
      return;
    }

    viewEntered = $.session.CaseNotesViewEntered ? filterData.viewEnteredByOtherUsers : false;

    const daysBackDate = new Date();
    daysBackDate.setDate(daysBackDate.getDate() - filterData.viewNotesDaysBack);
    const serviceDateStart = UTIL.formatDateFromDateObj(daysBackDate);

    const consumer = filterData.consumerId;
    const consumerName = filterData.consumerName;

    initFilterValues({ consumer, consumerName, serviceDateStart });
    initialData();
  }

  return {
    init,
    permissions_Table,
    handleActionNavEvent,
    isEditing,
    getReportFilterValue,
  };
})();
